.integrationContainer {
    padding: 0px 0px 20px 0px;
}
.integrationRowContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.integrationConfigurationIcon {
    background:transparent;
    border: none;
    color: var(--hps-blue);
}

.configurationErrorsIcon {
    margin-left: 5px;
    background:transparent;
    border: none;
    color: var(--hps-red);
}

.setupLink {
    margin-left: 30px;
}